import styled from 'styled-components';

export const Main = styled.section`
	width: 100%;
	min-height: calc(100vh - (${({ theme }) => theme.spacing.headerHeight} + ${({ theme }) => theme.spacing.footerHeight} + 3rem + 4rem));
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin: 0 auto;
	gap: 7.4375rem;

	@media screen and (max-width: 1020px) {
		padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.xl};
		flex-direction: column-reverse;
		align-items: center;
		justify-content: center;
		gap: ${({ theme }) => theme.spacing.m};
	}

	@media screen and (max-width: 900px) {
		flex-direction: column;
	}

	@media screen and (max-width: 762px) {
		padding: 1.5rem;
	}

	@media screen and (max-width: 500px) {
		padding: 0;
		margin: 0 auto;
		border-bottom: 1px solid ${({ theme }) => theme.colors.auxiliary.green};
		gap: 0;
	}
`;

export const FormWrapper = styled.div`
	width: 100%;
	max-width: 28.1875rem;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing.s};
	margin-top: 11.625rem;
	margin-bottom: 11.4375rem;

	h1 {
		font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeXL};
		line-height: ${({ theme }) => theme.lineHeight.lineHeight.lineHeightMedium};
		position: relative;
		padding-bottom: 0.5rem;
		&::after {
			content: '';
			position: absolute;
			left: 0;
			bottom: 0;
			height: 2px;
			width: 45%;
			background-color: ${({ theme }) => theme.colors.secondary.health_green};
		}
	}

	@media screen and (max-width: 1020px) {
		margin-top: -2rem;
		max-width: none;
		margin-bottom: 0;
	}

	@media screen and (max-width: 762px) {
		margin-top: 2rem;
	}
	@media screen and (max-width: 500px) {
		margin-top: 1.5rem;
		gap: 1.5rem;
	}
`;

export const InputsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing.m};
	width: 100%;

	@media screen and (max-width: 500px) {
		div:first-child {
			padding-bottom: ${({ theme }) => theme.spacing['2xs']};
		}
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	max-width: 34.125rem;
	max-height: 28.1875rem;
	margin-top: ${({ theme }) => theme.spacing['2xl']};
	margin-bottom: ${({ theme }) => theme.spacing.layoutl};

	@media screen and (max-width: 500px) {
		margin-top: ${({ theme }) => theme.spacing.l};
	}
	.image {
		width: 100%;
		height: auto;
		max-height: 100%;

		@media screen and (max-width: 900px) {
			max-width: 100%;
		}
	}

	.image-credits {
		color: ${({ theme }) => theme.colors.gray.dark};
		font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeXS};
		white-space: nowrap;
		text-align: right;

		.anchor-image {
			cursor: pointer;
			color: ${({ theme }) => theme.colors.gray.dark};
			text-decoration: none;
		}
	}
`;
